import { CallMerge, WbSunnyOutlined } from "@mui/icons-material";
import AirIcon from "@mui/icons-material/Air";
// import DewPointIcon from "@mui/icons-material/DewPoint";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CompressIcon from "@mui/icons-material/Compress";
import {
  IconCloud,
  IconCloudFog,
  IconCloudStorm,
  IconEye,
  IconSun,
  IconSunHigh,
  IconSunLow,
  IconWind,
} from "@tabler/icons-react";
const AirportWeather = ({ weather, name }) => {
  const {
    airTemperature,
    dewPoint,
    cloudCover,
    phenomenaGroups,
    validFrom,
    wind,
    visibility,
    pressure,
  } = weather;
  console.log(wind);

  const getCondition = () => {
    if (phenomenaGroups.includes("RA")) return "Rainy";
    if (phenomenaGroups.includes("TSRA")) return "Stormy";
    if (cloudCover === "Overcast") return "Cloudy";
    if (cloudCover === "Few") return "Sunny";
    return "Clear";
  };

  const getConditionIcon = () => {
    const condition = getCondition();
    switch (condition) {
      case "Rainy":
      case "Stormy":
        return <IconCloudStorm />;
      case "Cloudy":
        return <IconCloud />;
      case "Sunny":
        return <IconSunLow />;
      default:
        return <IconSun />;
    }
  };

  const getTimeAndDate = (dateStr) => {
    // Step 1: Remove timezone
    console.log(dateStr);
    const date = dateStr.split(" ")[0].trim(); // "2025-08-04 19:00"

    // Step 2: Extract date and time
    const time = dateStr.split(" ")[1].slice(0, 5);
    console.log(time); // date = "2025-08-04", time = "19:00"

    // Step 3: Format date as "04 Aug 25"
    const dateObj = new Date(date);
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = dateObj.toLocaleString("en-US", { month: "short" });
    const year = String(dateObj.getFullYear()).slice(-2);
    const formattedDate = `${day} ${month} ${year}`; // "04 Aug 25"

    const [hourStr, minute] = time.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";

    hour = hour % 12;
    hour = hour === 0 ? 12 : hour; // handle midnight and noon

    // return `${hour}:${minute} ${ampm}`;

    return { date: formattedDate, time: `${hour}:${minute} ${ampm}` };
  };
  return (
    <div className={`weather-item-wrapper ${getCondition()}`}>
      <span className="absolute-icon">{getConditionIcon()}</span>
      <div className="weather-top">
        <div className="weather-temp">
          <span className="weather-feel">
            {getConditionIcon()}
            {getCondition()}
          </span>
          <span className="weather-temp-celcious">{airTemperature.f}°</span>
        </div>

        <div className="weather-time">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span className="time">{getTimeAndDate(validFrom.local).time}</span>
            <span className="date">{getTimeAndDate(validFrom.local).date}</span>
          </div>

          <span className="place-name">{name}</span>
        </div>
      </div>

      <div className={`weather-bottom ${getCondition() + "-bottom"}`}>
        <div className="weather-info">
          <IconWind /> {wind?.speed?.kmPerHour} k/h
        </div>

        <div className="weather-info">
          <IconCloudFog /> {dewPoint?.f}°F
        </div>

        <div className="weather-info">
          <IconEye /> {visibility?.km} km
        </div>

        <div className="weather-info">
          <CompressIcon /> {pressure?.hPa} hpa
        </div>
      </div>
    </div>
  );
};

export default AirportWeather;
